fragment SupplierControlPanelProductProfitFragment on SupplierControlPanelProductProfit {
    id
    supplier_id
    original_sku
    mec_sku
    enabled
    product_name_en
    product_profit_grade
    categories
}